import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { formatPhoneNumber } from '../../pages/ClientIntake';

export default function PersonalInfoStep({ form, updateForm }) {
    const el = React.createElement;
    const u = (f, v) => updateForm({ [f]: v });
    
    return el('div', { className: 'space-y-6' },
        // Legal Name
        el('div', { className: 'space-y-2' },
            el('h3', { className: 'font-medium text-sm text-muted-foreground' }, 'LEGAL NAME'),
            el('div', { className: 'grid grid-cols-1 md:grid-cols-3 gap-4' },
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'First Name *'),
                    el(Input, { 
                        value: form.first_name || '', 
                        onChange: e => u('first_name', e.target.value), 
                        className: 'rounded-none',
                        'data-testid': 'personal-first-name-input'
                    })
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Middle Name'),
                    el(Input, { 
                        value: form.middle_name || '', 
                        onChange: e => u('middle_name', e.target.value), 
                        className: 'rounded-none'
                    })
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Last Name *'),
                    el(Input, { 
                        value: form.last_name || '', 
                        onChange: e => u('last_name', e.target.value), 
                        className: 'rounded-none',
                        'data-testid': 'personal-last-name-input'
                    })
                )
            )
        ),
        
        // Date of Birth, SSN, Pronouns
        el('div', { className: 'grid grid-cols-1 md:grid-cols-3 gap-4' },
            el('div', { className: 'space-y-2' },
                el(Label, null, 'Date of Birth'),
                el(Input, { 
                    type: 'date', 
                    value: form.date_of_birth || '', 
                    onChange: e => u('date_of_birth', e.target.value), 
                    className: 'rounded-none',
                    'data-testid': 'dob-input'
                })
            ),
            el('div', { className: 'space-y-2' },
                el(Label, null, 'Last 4 of SSN'),
                el(Input, { 
                    maxLength: 4, 
                    value: form.ssn_last_four || '', 
                    onChange: e => u('ssn_last_four', e.target.value.replace(/\D/g, '')), 
                    className: 'rounded-none', 
                    placeholder: 'XXXX',
                    'data-testid': 'ssn-input'
                })
            ),
            el('div', { className: 'space-y-2' },
                el(Label, null, 'Pronouns'),
                el('select', { 
                    value: form.pronouns || '', 
                    onChange: e => u('pronouns', e.target.value),
                    className: 'w-full h-10 px-3 border border-input bg-background text-sm rounded-none focus:outline-none focus:ring-2 focus:ring-ring',
                    'data-testid': 'pronouns-select'
                },
                    el('option', { value: '' }, 'Select pronouns...'),
                    el('option', { value: 'he/him/his' }, 'He/Him/His'),
                    el('option', { value: 'she/her/hers' }, 'She/Her/Hers'),
                    el('option', { value: 'they/them/theirs' }, 'They/Them/Theirs')
                )
            )
        ),
        
        // Email & Phone
        el('div', { className: 'grid grid-cols-1 md:grid-cols-2 gap-4' },
            el('div', { className: 'space-y-2' },
                el(Label, null, 'Email'),
                el(Input, { 
                    type: 'email', 
                    value: form.email || '', 
                    onChange: e => u('email', e.target.value), 
                    className: 'rounded-none', 
                    'data-testid': 'email-input' 
                })
            ),
            el('div', { className: 'space-y-2' },
                el(Label, null, 'Phone'),
                el(Input, { 
                    type: 'tel', 
                    value: form.phone || '', 
                    onChange: e => u('phone', formatPhoneNumber(e.target.value)), 
                    className: 'rounded-none',
                    placeholder: '(555) 555-5555',
                    'data-testid': 'phone-input'
                })
            )
        )
    );
}
